import { AnimatePresence } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Footer } from '../interface/Footer';
import { Header } from '../interface/Header';
import { Loader } from '../interface/Loader';
import { Road } from '../routes/Road';
import apiCallsService from '../services/apiCalls.service';
import { useDispatch } from 'react-redux';
import { addData } from '../redux/dataRedux';
import { addCategory } from '../redux/categoryRedux';
import { addTerms } from '../redux/termsDataRedux';
import { ModalContainer } from '../promoCodes/modalContainer';
import { SubscribeModalContainer } from '../promoCodes/subscribeContainer';
import { useLocation } from 'react-router-dom';



const Wrapper = styled.div`
	height: calc(100vh - 4rem);
	max-width: 192rem;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	padding-top: 1rem;
	@media screen and (max-width: 1100px) {
		margin-bottom: 4rem;
		height: auto;
		overflow: hidden;
	}
`;

const Block = styled.div`
	position: relative;
	display: flex;
	height: 100%;
	border-bottom: 1px solid ${props => props.theme.colorBorder};
	@media screen and (max-width: 1100px) {
		border-bottom: unset;
	}
`;

const Right = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	@media screen and (max-width: 1100px) {
		width: 100%;
	}
`;

const Group = styled.div`
	position: relative;
	display: flex;
	align-items: flex-start;
	height: calc(100% - 4.6rem);
	@media screen and (max-width: 1100px) {
		width: 100%;
		height: calc(100% - 9.2rem);
		margin-left: 0;
	}
	@media screen and (max-width: 850px) {
		height: 100%;
	}
`;

export const Home = () => {
	const [loaded, setLoaded] = useState(false);
	const dispatch = useDispatch();
	const [promoData, setPromoData] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			const responseProducts = await apiCallsService.getProductsRequest();
			const responseCategories = await apiCallsService.getCategoriesRequest();
			const responseTerms = await apiCallsService.getTermsRequest();
			try{
				const url = new URL(document.location); // or document.location
				const promoCode = url.searchParams.get('promoCode')
				if (promoCode !== null & promoCode !== '') {
					try {
						//console.log(promoCode)
						const responsePromoCode = await apiCallsService.getPromoRequest({code: promoCode});
						//console.log(responsePromoCode)
						if (responsePromoCode !== null) {
							let responsePromoCodeUsed = JSON.parse(localStorage.getItem('promoCodeU'));
							if (responsePromoCodeUsed !== null) {
								if (!responsePromoCodeUsed.includes(promoCode)) {
									setPromoData(responsePromoCode);
									localStorage.setItem('promoCode', JSON.stringify({code: promoCode}));
								}
							}
							else {
								setPromoData(responsePromoCode);
								localStorage.setItem('promoCode', JSON.stringify({code: promoCode}));
							}

						}


						

					}
					catch(err) {}
				}
			}catch(e){}
			

			responseProducts.error
				? dispatch(addData([]))
				: dispatch(addData(responseProducts));

			responseCategories.error
				? dispatch(addCategory([]))
				: dispatch(addCategory(responseCategories));

			responseTerms.error
				? dispatch(addTerms([]))
				: dispatch(addTerms(responseTerms));

			setLoaded(true);
		};

		fetchData();
	}, [dispatch]);


	const [modalActive, setModalActive] = useState(true);


	return (
		<>
			<AnimatePresence>{loaded ? null : <Loader />}</AnimatePresence>
			<Wrapper>
				{promoData !== null && (<ModalContainer props={promoData} active={modalActive} setActive={setModalActive} />)}

				<Block>
					<Right>
						<Header />
						<Group>
							<Road />
						</Group>
					</Right>
				</Block>
				<Footer />
			</Wrapper>
		</>
	);
};
